module.exports = __webpack_public_path__ + "static/media/Colette Curve Super King Headboard - 200 cm_Burnt Orange.e2ed0f30.png";